<template>
  <form-wrapper>
    <form-group>
      <text-input :value="stepFormData.phone" :label="$t('application-form.step-1.phone')" disabled />
      <text-input :value="stepFormData.email" :label="$t('application-form.step-1.email')" disabled />
    </form-group>
    <form-group>
      <validation-provider v-slot="{errors}" rules="required|min:2|max:256|ua_letters_space_hyphen">
        <text-input
          ref="firstInput"
          :label="$t('application-form.step-1.last-name')"
          placeholder="Івашкевич"
          required
          :hint="$t('application-form.step-1.last-name-hint-uk')"
          :errors="[...errors, ...getFieldErrors('last_name')]"
          :value="stepFormData.last_name"
          @input="emitInput('last_name', $event)"
        />
      </validation-provider>
      <validation-provider v-slot="{errors}" rules="required|min:2|max:256|ua_letters_space_hyphen">
        <text-input
          :value="stepFormData.first_name"
          :hint="$t('application-form.step-1.first-name-hint-uk')"
          :label="$t('application-form.step-1.first-name')"
          placeholder="Ігор"
          required
          :errors="[...errors, ...getFieldErrors('first_name')]"
          @input="emitInput('first_name', $event)"
        />
      </validation-provider>
      <validation-provider v-slot="{errors}" rules="max:256|ua_letters_space_hyphen">
        <text-input
          :hint="$t('application-form.step-1.middle-name-hint-uk')"
          :value="stepFormData.middle_name"
          :label="$t('application-form.step-1.middle-name')"
          placeholder="Віталійович"
          :errors="[...errors, ...getFieldErrors('middle_name')]"
          @input="emitInput('middle_name', $event)"
        />
      </validation-provider>
    </form-group>
    <form-group>
      <validation-provider v-slot="{errors}" rules="required|full_age">
        <date-input
          :errors="[...errors, ...getFieldErrors('birth_date')]"
          :value="stepFormData.birth_date"
          :v-calendar-options="{maxDate: $options.dateNow}"
          :label="$t('application-form.step-1.date-of-birth')"
          placeholder="25.09.1981"
          required
          :hint="$t('application-form.step-1.date-of-birth-hint')"
          @input="emitInput('birth_date', $event)"
        />
      </validation-provider>
      <validation-provider v-slot="{errors}" rules="required|ua_birth_place|min:3|max:256">
        <text-input
          :errors="[...errors, ...getFieldErrors('birth_city')]"
          :value="stepFormData.birth_city"
          :label="$t('application-form.step-1.place-of-birth')"
          :placeholder="isResident? 'Львів': 'Lviv'"
          required
          :hint="$t('application-form.step-1.place-of-birth-hint')"
          @input="emitInput('birth_city', $event)"
        />
      </validation-provider>
    </form-group>
    <form-group>
      <validation-provider v-slot="{errors}" rules="required">
        <text-input
          :errors="[...errors, ...getFieldErrors('citizenship')]"
          :value="getCountryName(stepFormData.citizenship)"
          :label="$t('application-form.step-1.citizenship')"
          placeholder="Україна"
          required
          :disabled="true"
        />
      </validation-provider>
    </form-group>
    <form-group>
      <!--      Todo-->
      <checkbox-input :value="stepFormData.has_inn" @input="changeHasInn">
        {{ $t('application-form.step-1.has-inn') }}
      </checkbox-input>

      <template v-if="stepFormData.has_inn">
        <validation-provider v-slot="{errors}" slim rules="required|identify_code">
          <text-input
            :errors="[...errors, ...getFieldErrors('inn')]"
            :value="stepFormData.inn"
            :label="$t('application-form.step-1.tax-id-number')"
            placeholder="3158309531"
            mask="0000000000"
            required
            :hint="$t('application-form.step-1.tax-id-number-hint')"
            @input="emitInput('inn', $event)"
          />
        </validation-provider>
        <validation-provider v-slot="{errors, validate}" slim rules="required_files|files_has_no_errors">
          <icu-dropzone
            :title="$t('application-form.step-1.photo-scan-tax-id')"
            :errors="[...getFieldErrors('photo_inn'), ...errors]"
            :maximum-files="1"
            :is-resident="isResident"
            :value="stepFormData.photo_inn"
            @input="emitFile('photo_inn', $event)"
            @delete-file="deleteFile('photo_inn', $event)"
            @files-uploaded="validate"
          />
        </validation-provider>
      </template>
      <validation-provider
        v-if="!stepFormData.has_inn && isCitizen"
        v-slot="{errors, validate}"
        slim
        rules="required_files|files_has_no_errors"
      >
        <icu-dropzone
          :title="$t('application-form.step-1.photo-scan-without-ipn')"
          :errors="[...getFieldErrors('photo_inn'), ...errors,]"
          :maximum-files="1"
          :is-resident="isResident"
          :value="stepFormData.photo_inn"
          @input="emitFile('photo_inn', $event)"
          @delete-file="deleteFile('photo_inn', $event)"
          @files-uploaded="validate"
        />
      </validation-provider>
    </form-group>
  </form-wrapper>
</template>

<script>
import TextInput from '@/components/inputs/TextInput.vue'
import FormWrapper from '@/components/views/RegisterPage/FormWrapper.vue'
import FormGroup from '@/components/views/RegisterPage/FormGroup.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import IcuDropzone from '@/components/inputs/IcuDropzone.vue'
import { ValidationProvider } from 'vee-validate'
import CheckboxInput from '@/components/inputs/CheckboxInput.vue'

export default {
  name: 'FirstStep',
  components: { CheckboxInput, IcuDropzone, DateInput, FormGroup, FormWrapper, TextInput, ValidationProvider },
  props: {
    stepFormData: {
      type: Object,
      required: true
    },
    backendErrors: {
      type: Object,
      default: () => {}
    },
    countries: {
      type: Array,
      default:()=> []
    },
    isResident:{
      type: Boolean,
      required: true
    },
    isCitizen: {
      type: Boolean,
      default: true
    }
  },
  dateNow: new Date(),
  mounted() {
    this.$refs.firstInput.focus()
  },
  methods: {
    getCountryName(id) {
      if(id) {
        const countryObj = this.countries.find(el => el.id === id)
        return countryObj.name
      }
      return ''
    },
    emitInput(formKey, value) {
      this.$emit('update-field', {formKey, value})
    },
    emitFile(formKey, file) {
      this.$emit('add-file', {formKey, file})
    },
    deleteFile(formKey, file) {
      this.$emit('delete-file', {formKey, file})
    },
    getFieldErrors(fieldName) {
      return this.backendErrors[fieldName] ?? []
    },
    changeHasInn(value) {
      this.emitInput('has_inn', value)
      this.emitInput('inn', '')
      this.emitInput('photo_inn', [])
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
</style>
